import SbuxDialog2 from "../../../../components/SbuxDialog2";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { dialByPhoneNumber } from "../../../content/common/agentCall";
import { useAppDispatch } from "../../../../store/types";
import { setHistoryDialNumberValidateStatus } from "../../../../services/history";

interface PhoneNumberDialogProps {
  openDialPrompt: boolean;
  parsedPhoneNumber: {
    formattedPhoneNumber: string;
    phoneNumber: string;
  } | null;
  toggleOpenDialPrompt: () => void;
}

const PhoneNumberDialog = ({
  openDialPrompt,
  parsedPhoneNumber,
  toggleOpenDialPrompt,
}: PhoneNumberDialogProps) => {
  const dispatch = useAppDispatch();

  const handleOkayDialNumber = () => {
    dispatch(setHistoryDialNumberValidateStatus(null));
    if (parsedPhoneNumber) {
      dialByPhoneNumber(
        parsedPhoneNumber.formattedPhoneNumber,
        toggleOpenDialPrompt,
        dispatch,
      );
    }
  };

  const dialogConfig = {
    title: <SbuxTranslate>{`Dial Phone Number`}</SbuxTranslate>,
    hasBackdrop: false,
    asModal: true,
    disableBackdropClose: false,
  };

  return (
    <SbuxDialog2
      open={openDialPrompt}
      config={dialogConfig}
      handleOnClose={toggleOpenDialPrompt}
    >
      <DialogContent dividers>
        <Typography variant="h5">
          <SbuxTranslate>{`Are you sure you would like to dial`}</SbuxTranslate>
          <span>{` ${parsedPhoneNumber?.phoneNumber}?`}</span>
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box className="actionContainer">
          <Button
            variant="contained"
            size="medium"
            onClick={handleOkayDialNumber}
          >
            <SbuxTranslate>{"Okay"}</SbuxTranslate>
          </Button>
          <Button
            variant="outlined"
            size="medium"
            onClick={toggleOpenDialPrompt}
          >
            <SbuxTranslate>{"Cancel"}</SbuxTranslate>
          </Button>
        </Box>
      </DialogActions>
    </SbuxDialog2>
  );
};

export default PhoneNumberDialog;
